<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row v-if="this.segments.dateName === true">
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Zákazník</h4>
      </v-col>
      <v-col cols="auto" md="4">
        <div class="request-label">
          Jméno/Obchodní firma
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationName }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Datum narození/IČ
        </div>
        <div class="pt-2 black--text request-value">
          {{
            checkIdentificationNumber(bulkOtherChange.organizationId)
              ? bulkOtherChange.organizationId
              : dateFormatting(bulkOtherChange.organizationId)
          }}
        </div>
      </v-col>
    </v-row>

    <v-row v-if="this.segments.billingAddress === true">
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Fakturační adresa</h4>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Město
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationCity || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="9">
        <div class="request-label">
          Místní část
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationCitySection || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Ulice
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationStreetName || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo popisné
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationHouseNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo orientační
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationStreetNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          PSČ
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.organizationZipCode || missingValueString }}
        </div>
      </v-col>
    </v-row>

    <v-row v-if="this.segments.contactPerson === true">
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Kontaktní osoba</h4>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Jméno
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.contactName || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Telefon
        </div>
        <div class="pt-2 black--text request-value">
          {{ formatPhoneNumber(bulkOtherChange.contactPhone) || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="6">
        <div class="request-label">
          E-mail
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.contactEmail || missingValueString }}
        </div>
      </v-col>
    </v-row>

    <v-row v-if="this.segments.supplyPointAddress === true">
      <v-col cols="12" class="request-label v-card__title pb-0 pl-3">
        <h4>Adresa/Umístění odběrného místa</h4>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Obec/Město
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerCity || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="9">
        <div class="request-label">
          Místní část
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerCitySection || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="3">
        <div class="request-label">
          Ulice
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerStreetName || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo popisné
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerHouseNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          Číslo orientační
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerStreetNumber || missingValueString }}
        </div>
      </v-col>
      <v-col cols="auto" md="2">
        <div class="request-label">
          PSČ
        </div>
        <div class="pt-2 black--text request-value">
          {{ bulkOtherChange.consumerZipCode || missingValueString }}
        </div>
      </v-col>
    </v-row>

    <v-row v-if="this.segments.distributionStart === true"
      class="mt-5"
    >
      <v-col cols="auto" md="5" class="request-label">
        Požadovaný termín zahájení distribuce
      </v-col>
      <v-col cols="auto" md="5" class="black--text request-value">
        {{ formatDate(bulkOtherChange.distributionStartDate) || missingValueString }}
      </v-col>
    </v-row>

    <v-row v-if="this.segments.distributionEnd === true">
      <v-col cols="auto" md="5" class="request-label">
        Požadovaný termín ukončení distribuce
      </v-col>
      <v-col cols="auto" md="5" class="black--text request-value">
        {{ formatDate(bulkOtherChange.distributionEndDate) || missingValueString }}
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'BulkOtherChangeInsertedValues',
  mixins: [formatPhoneNumber],
  props: {
    bulkOtherChange: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      segments: {
        dateName: false,
        billingAddress: false,
        contactPerson: false,
        supplyPointAddress: false,
        distributionStart: false,
        distributionEnd: false,
      },
    };
  },
  methods: {
    checkSegments() {
      if (
        this.bulkOtherChange.opmState === 'TWO_A'
        || this.bulkOtherChange.opmState === 'THREE'
        || this.bulkOtherChange.opmState === 'FIVE_A'
        || this.bulkOtherChange.opmState === 'FIVE_B'
        || this.bulkOtherChange.opmState === 'FIVE_C'
        || this.bulkOtherChange.opmState === 'FIVE_D'
        || this.bulkOtherChange.opmState === 'FIVE_E'
        || this.bulkOtherChange.opmState === 'FIVE_F'
      ) {
        this.segments.dateName = true;
        this.segments.contactPerson = true;
      }
      if (
        this.bulkOtherChange.opmState === 'TWO_B'
        || this.bulkOtherChange.opmState === 'THREE'
        || this.bulkOtherChange.opmState === 'FIVE_A'
        || this.bulkOtherChange.opmState === 'FIVE_B'
        || this.bulkOtherChange.opmState === 'FIVE_C'
        || this.bulkOtherChange.opmState === 'FIVE_D'
        || this.bulkOtherChange.opmState === 'FIVE_E'
        || this.bulkOtherChange.opmState === 'FIVE_F'
      ) {
        this.segments.billingAddress = true;
      }
      if (this.bulkOtherChange.opmState === 'TWO_C') {
        this.segments.supplyPointAddress = true;
      }
      if (this.bulkOtherChange.opmState !== 'SIX') {
        this.segments.distributionStart = true;
      }
      if (this.bulkOtherChange.opmState === 'FIVE_F' || this.bulkOtherChange.opmState === 'SIX') {
        this.segments.distributionEnd = true;
      }
    },
    checkIdentificationNumber(value) {
      const isIc = /^\d{8}/.test(value);
      return isIc;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
  created() {
    this.checkSegments();
  },
};
</script>
